import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const pendingInvite = localStorage.getItem("bizarre_pending_invite") || undefined;
        const { data } = await api.post("/auth/google", { session_id: sessionId, invite_code: pendingInvite });
        localStorage.removeItem("bizarre_pending_invite");
        loginWithToken(data.token, data.user);
        window.history.replaceState(null, "", "/");
        navigate("/");
      } catch (e) {
        window.history.replaceState(null, "", "/login");
        toast.error(apiErr(e) || "Connexion Google impossible.");
        navigate("/login");
      }
    })();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="w-10 h-10 rounded-full border-2 border-white/10 border-t-[#D4AF37] animate-spin" />
    </div>
  );
}
